import { useLanguage } from "@/context/LanguageContext";
import DEVELOPER_CREDIT from "@/config/developerCredit.json";

const WEBSITE_DEVELOPMENT_URL = DEVELOPER_CREDIT.url;

export const FooterDeveloperCredit = () => {
  const { t } = useLanguage();
  return (
  <div
    data-testid="footer-developer-section"
    className="mt-5 flex flex-col gap-4 border-t border-slate-800 pt-5 text-xs lg:flex-row lg:items-center lg:justify-between"
  >
    <p data-testid="footer-developer-credit" className="min-w-0 leading-6 text-slate-400 lg:max-w-xl">
      {t(DEVELOPER_CREDIT.credit)}{" "}
      <a
        data-testid="footer-developer-link"
        href={WEBSITE_DEVELOPMENT_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="rounded-sm font-medium text-slate-200 underline decoration-slate-600 underline-offset-4 transition-colors hover:text-amber-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-amber-400"
      >
        {DEVELOPER_CREDIT.name}
        <span className="sr-only">{t(" (opens in a new tab)")}</span>
      </a>
    </p>
    <div className="flex min-w-0 flex-col items-start gap-3 sm:flex-row sm:flex-wrap sm:items-center lg:justify-end">
      <p className="leading-5 text-slate-300">{t(DEVELOPER_CREDIT.ctaTitle)}</p>
      <a
        data-testid="footer-website-cta"
        href={WEBSITE_DEVELOPMENT_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t(`${DEVELOPER_CREDIT.ctaLabel} from {developerName} (opens in a new tab)`, { developerName: DEVELOPER_CREDIT.name })}
        className="inline-flex min-h-[44px] max-w-full items-center justify-center rounded-full border border-slate-600 px-4 py-2 text-xs font-semibold text-slate-100 transition-colors hover:border-amber-400 hover:text-amber-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-amber-400"
      >
        {t(DEVELOPER_CREDIT.ctaLabel)}
      </a>
    </div>
  </div>
  );
};
